import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '../../../../constants/Colors';
import Style from '../../../../constants/Style';

const DotsRow = () => <>
  <View style={[Style.row, styles.dotsRow]}>
    {[...Array(30).keys()].map((dotIndex: number) => <View
      style={styles.dot}
      key={`dot_first_row_${dotIndex}`}
    />)}
  </View>
  <View style={[Style.row, styles.dotsRow]}>
    {[...Array(30).keys()].map((dotIndex: number) => <View
      style={styles.dot}
      key={`dot_second_row_${dotIndex}`}
    />)}
  </View>
</>;

const styles = StyleSheet.create({
  dotsRow: {
    overflow: 'hidden',
    flexShrink: 1,
    zIndex: -1,
  },
  dot: {
    width: 3,
    height: 3,
    borderRadius: 3,
    backgroundColor: Colors.light.hereworksDarkBlue100,
    marginHorizontal: 5,
    marginTop: 10,
  },
});

export default DotsRow;
